import client from './client';

export const classifyIntentDryRun = async ({ message, context }) => {
  const response = await client.post('/api/v1/test/intent', {
    message,
    context,
  });
  return response.data;
};
